import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider, Layout } from "antd";

import it_IT from "antd/es/locale/it_IT";
import es_ES from "antd/es/locale/es_ES";
import UserVoice from "../../components/general/userVoice";

import { loadStudios, loadStudiosCompany } from "../../store/actions/studio/index";
import { loadUser } from "../../store/actions/users/index";
import { logout, refreshTokenByGetParam } from "../../store/actions/auth";
import { ENV, FEATURE_TOGGLE_MULTILANGUAGE, UNDER_MAINTENANCE } from "../../config.js";
import { useCheckResolution } from "../../customHooks/useCheckResolution.js";
import useGetCompanies from "../../customHooks/useGetCompanies.js";

import BrowserNotSupported from "../../components/general/not-supported.jsx";
import BrowserNotSupportedDevice from "../../components/general/not-supported-device.jsx";
import Init from "./init";
import Maintenance from "../../components/general/maintenance.jsx";
import ChooserStudio from "./chooserStudio.jsx";
import Login from "../../components/login";
import SpinnerFullPage from "../../components/general/spinner/index";

import ParentApp from "@mondora/microfrontends/lib/ParentApp";
import moment from "moment";
import "moment/locale/it";
import numeral from "numeral";
import "numeral/locales";
import { updateLoginData } from "../../libs/unifiedLogin";
import { loadCompany } from "../../store/actions/company";
import { useLocation } from "react-router-dom";
import { sessionStart } from "../../store/actions/analytics";
import useChangeCompany from "../../customHooks/useChangeCompany";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";
import { identifyUserAndAccount } from "../../libs/utils";
import { getCurrentCookieConsents } from "../../libs/cookie-consent-utils.js";
import sha256 from "sha256";
// import { identifyUserAndAccount } from "../../libs/utils";

// switch between locales
numeral.locale("it");
moment.locale("it");

const Root = () => {
  /** LOGIN UNIFICATA url /#/integrated=true */

  const location = useLocation();
  const url = new URL(window.location.href.replace("#/", ""));
  const urlParamIntegrated = url.searchParams.get("integrated");
  const isIntegrated = urlParamIntegrated ? true : false;

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const company = useSelector((state) => state.company);
  const device = useCheckResolution();
  const main = useSelector((state) => state.main);
  const sso = useSelector((state) => state.sso);
  const studio = useSelector((state) => state.studio);
  const user = useSelector((state) => state.user);
  const currentPermissions = useSelector((state) => state.currentPermissions);

  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [toRenderBlock, setToRenderBlock] = useState(null);
  const [visibleStudioModal, setVisibleStudioModal] = useState(false);
  const [parentAppData, setParentAppData] = useState({});
  const { changeCompanySelected } = useChangeCompany();
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [mountIdentify, setMountIdentify] = useState(false);

  const { getCompanies } = useGetCompanies();

  const studioFind = GetSelectedCompanyStudio();

  const { C0005: profilingCookiesAccepted } = getCurrentCookieConsents();
  const normalizeAndHash = (s) => s && sha256(s.toLowerCase().trim());

  useEffect(() => {
    /*
    localStorage.removeItem("selectedClientID");
    localStorage.removeItem("selectedAccountantID");
    */
    if (isIntegrated) {
      dispatch({ type: "setIntegrated" });
    } else {
      // questo a regime non servirà più
      dispatch({ type: "removeIntegrated" });
    }

    localStorage.setItem("isCheckingTokenDBX", "false");
  }, []); // empty array => run only once

  useEffect(() => {
    if (main.myType === "STUDIO") {
      const studioList = studio?.list;

      if (!studioList) {
        dispatch(loadStudios(main.auth))
          .then(() => {})
          .catch((err) => {
            if (err.status === 401) {
              dispatch(logout());
            }
          });
      }
    }
  }, [main]);

  useEffect(() => {
    // in caso di errore auth, per evitare lo spinner infinito faccio in modo che vada  in logout
    if (auth.status.error && auth?.status?.errorInfo?.code !== "401") {
      dispatch(logout());
    }
  }, [auth.status.error]);

  useEffect(() => {
    if (!main.isIntegrated) {
      return;
    }

    new ParentApp({
      onLaunch: (params) => {
        setParentAppData(params);
        updateLoginData(params, dispatch);
      },
      parentOrigin: "http://localhost:3000", // "https://app.teamsystemdigital.com"
    });
  }, [main.isIntegrated]);

  useEffect(() => {
    if (auth.status.ended && sso.ssoAuth && isFirstLogin) {
      window.location.href = global.location.pathname;
    }
  }, [auth.loginAuth]);

  useEffect(() => {
    /**
     * Recupero info user, companies e le sottoscrizioni.
     * Nota bene avendo come 2 parametro di useEffect auth.loginAuth questa if verrà
     * richiamata solo e solo se cambia auth.loginAuth
     */

    if (
      typeof auth.loginAuth?.id !== "undefined" &&
      typeof user.profile === "undefined" &&
      !user.status.started &&
      !user.status.error &&
      /* !user.status.ended &&*/
      !main.isIntegrated
    ) {
      dispatch(loadUser()).then((result) => {
        if (!company.status.ended && !company.status.started && !company.status.error) {
          dispatch(loadStudios(auth)).then((studios) => {
            let userType = "";
            // se ci sono studi allora sei commercialista

            if (studios.data.length > 0) {
              userType = "STUDIO";

              if (studios.data.length === 1) {
                // INIZIO CUSTOMIZZAZIONE PER NON SELEZIONARE AUTOMATICAMENTE STUDI NON VALIDATI
                if (studios.data[0]?.additionalData?.status?.status !== "VALIDATED") {
                  dispatch({
                    type: "setUserType",
                    userType: userType,
                  });
                  // FINE CUSTOMIZZAZIONE PER NON SELEZIONARE AUTOMATICAMENTE STUDI NON VALIDATI
                } else {
                  localStorage.setItem("studioSelected", studios.data[0].codiceFiscale);
                  localStorage.setItem("selectedAccountantID", studios.data[0].id);
                  localStorage.setItem("actualAccountantName", studios.data[0].ragioneSociale);
                  getCompanies(userType, studios.data, studios.data[0].id);
                  dispatch({
                    type: "changeAccountant",
                    accountantUuidSelected: studios.data[0].uuid,
                    accountantIdSelected: studios.data[0].id,
                    accountantSelected: studios.data[0].codiceFiscale,
                    myType: userType,
                  });
                }
              } else {
                dispatch({
                  type: "setUserType",
                  userType: userType,
                });
              }
            }
            /** Solo se != STUDIO carico subito le companies,
             * altrimenti aspetto di selezionare il commercialista */
            if (userType !== "STUDIO") {
              getCompanies(userType, studios.data);
            }
          });
        }
      });
    }
    if (auth.loginAuth && parentAppData.item && main.isIntegrated && (main.accountantIdSelected.length > 0 || main.clientIdSelected.length > 0)) {
      dispatch(loadUser()).then((result) => {
        dispatch(main.clientIdSelected.length === 0 ? loadStudios() : loadStudiosCompany()).then((studios) => {
          let userType = "";
          // se ci sono studi allora sei commercialista, o se è presente company in myType lascio COMPANY come valore
          if (studios.data.length > 0) {
            setVisibleStudioModal(!main.accountantIdSelected);
            userType = parentAppData.item.classifier === "STUDIO" ? "STUDIO" : "COMPANY";

            if (studios.data.length === 1) {
              localStorage.setItem("studioSelected", studios.data[0].codiceFiscale);
              localStorage.setItem("selectedAccountantID", studios.data[0].id);
              localStorage.setItem("actualAccountantName", studios.data[0].ragioneSociale);
              getCompanies(userType, studios.data, studios.data[0].id);
              dispatch({
                type: "changeAccountant",
                accountantUuidSelected: studios.data[0].uuid,
                accountantIdSelected: studios.data[0].id,
                accountantSelected: studios.data[0].codiceFiscale,
                myType: userType,
              });
            } else {
              getCompanies(userType, studios.data, main.accountantIdSelected);
              dispatch({
                type: "setUserType",
                userType: userType,
              });
            }
          }
          /** Solo se != STUDIO carico subito le companies,
           * altrimenti aspetto di selezionare il commercialista */
          if (userType !== "STUDIO") {
            getCompanies(userType, studios.data);
          }
        });
      });
    }
    // setto nello storage per il createHttpHeader che al momento cerca dallo storage per X-item e X-manager
    localStorage.setItem("selectedClientID", main.clientIdSelected);
    localStorage.setItem("selectedAccountantID", main.accountantIdSelected);

    if (!company?.companies && main.accountantIdSelected && !company.status.started && auth.loginAuth) {
      // ho il main in whitelist per operare con lo stesso cliente al refresh
      dispatch(loadCompany());
      // setto nello storage per il createHttpHeader che al momento cerca dallo storage per X-item e X-manager
    }
  }, [auth.loginAuth, auth?.status, main.clientIdSelected, main.accountantIdSelected, main.isIntegrated, parentAppData]);

  useEffect(() => {
    if (main.isIntegrated) {
      setVisibleStudioModal(!main.accountantIdSelected);
    }
  }, [main.accountantIdSelected]);

  useEffect(() => {
    let currentBlock;
    let checkTsPayCompleted = window.location.href.indexOf("/tspaycompleted") > 0;
    let checkTsPayConsentCompleted = window.location.href.indexOf("/tspayConsentsAccountsListCompleted") > 0;

    switch (true) {
      case studioFind && ["IT", "ES"].indexOf(studioFind?.taxRegion) === -1 && FEATURE_TOGGLE_MULTILANGUAGE === "true":
        currentBlock = (
          <div
            style={{ height: "90vh", color: "var(--brand-primary-shade-dark)", display: "flex", justifyContent: "center", alignItems: "center", fontSize: 20 }}
          >
            Al momento non è disponibile la versione di Digital Box per gli studi con sede diversa da Italia o Spagna.
          </div>
        );
        break;
      case device === "badResolution" && !checkTsPayCompleted && !checkTsPayConsentCompleted:
        currentBlock = <BrowserNotSupportedDevice device={device} />;
        break;
      case device !== "desktop":
        currentBlock = <BrowserNotSupported />;
        break;
      case UNDER_MAINTENANCE === "true" || (auth.status.errorInfo && auth.status.errorInfo.message === "Network Error"):
        currentBlock = <Maintenance />;
        break;
      case !isIntegrated && !auth.loginAuth && !auth.status.started && window.location.href.indexOf("/password-dimenticata") < 0:
        /* No sense !checkTsPayCompleted && */
        /* No sense &&
      !checkTsPayConsentCompleted */

        currentBlock = (
          <Layout className="Root">
            <Layout.Content className={null}>
              {studioFind?.taxRegion !== "ES" && user?.profile && <UserVoice user={user.profile ? user : null} userVoiceScript={window.UserVoice} />}
              <Login location={location} setFirstLogin={setIsFirstLogin} />
            </Layout.Content>
          </Layout>
        );
        break;
      // UN SOLO STUDIO MA NON ANCORA VALIDATO
      case (main.myType === "STUDIO" &&
        !main.accountantIdSelected &&
        studio.list &&
        studio.list.length === 1 &&
        studio?.list?.[0]?.additionalData?.status?.status !== "VALIDATED" &&
        ((main.accountantIdSelected === "" && !main.isIntegrated) || (main.accountantIdSelected === "" && main.isIntegrated && visibleStudioModal))) ||
        visibleStudioModal:
        currentBlock = (
          <ConfigProvider locale={["es", "ES", "es-ES"].indexOf(user?.profile?.language) > -1 ? es_ES : it_IT}>
            <ChooserStudio visibleStudioModal={visibleStudioModal} setVisibleStudioModal={setVisibleStudioModal} />
          </ConfigProvider>
        );
        break;
      case (main.myType === "STUDIO" &&
        !main.accountantIdSelected &&
        studio.list &&
        studio.list.length > 1 &&
        ((main.accountantIdSelected === "" && !main.isIntegrated) || (main.accountantIdSelected === "" && main.isIntegrated && visibleStudioModal))) ||
        visibleStudioModal:
        currentBlock = (
          <ConfigProvider locale={["es", "ES", "es-ES"].indexOf(user?.profile?.language) > -1 ? es_ES : it_IT}>
            <ChooserStudio visibleStudioModal={visibleStudioModal} setVisibleStudioModal={setVisibleStudioModal} />
          </ConfigProvider>
        );
        break;
      case !main.myType &&
        auth.status.started &&
        !auth.status.error &&
        window.location.href.indexOf("/password-dimenticata") < 0 &&
        !isIntegrated &&
        !currentPermissions?.permissionClient?.status?.error:
        currentBlock = <SpinnerFullPage myClass="fullPage" size="large" />;
        break;
      default:
        currentBlock = (
          <ConfigProvider locale={["es", "ES", "es-ES"].indexOf(user?.profile?.language) > -1 ? es_ES : it_IT}>
            <Init setIsFirstLogin={setIsFirstLogin} setVisibleStudioModal={setVisibleStudioModal} />
          </ConfigProvider>
        );
        break;
    }
    setToRenderBlock(currentBlock);
  }, [
    device,
    UNDER_MAINTENANCE,
    auth.status?.started,
    auth.status.errorInfo?.message,
    window.location.href,
    visibleStudioModal,
    main.accountantIdSelected,
    studio?.list,
    main.myType,
    auth.loginAuth,
    main.isIntegrated,
  ]);

  useEffect(() => {
    if (company.companies?.length > 0) {
      let idToChange = localStorage.getItem("selectedClientID") || company?.companies?.[0].id;
      dispatch(sessionStart(company?.companies?.find((x) => x.id === idToChange)?.uuid));
      changeCompanySelected(idToChange);
    }
  }, [company.companies]);

  /**
   * Per demo Launchpad
   */
  useEffect(() => {
    setIsRefreshed(true);
    const embedParameter = new URLSearchParams(location.search).get("token");
    if (isRefreshed || !embedParameter || auth.loginAuth) return;
    dispatch(refreshTokenByGetParam(embedParameter));
  }, [location, auth.loginAuth, isRefreshed]);

  useEffect(() => {
    if (studioFind?.taxRegion === "ES") {
      // Intercom init
      /* window.Intercom("boot", {
        app_id: "itizcavf",
        email: user?.profile?.email,
        user_id: user?.profile?.id,
        hide_default_launcher: false,
        vertical_padding: 40,
        // user_hash: "4dbc06357e1cd9878a92534d2c240c47737dcb4b6eb858cf26bb40eeaaf4b428"
        // Website visitor so may not have any user related info
      }); */
      // Fullview init
      window.$fvIdentity = {
        id: "DBX_" + user?.profile?.email, // Required - string - unique user identifier
        name: user?.profile?.email, // Required - string - user's name
        email: user?.profile?.email, // Optional - string - user's email
        env: ENV, // Optional - string - used for segmentation and environment-based settings
      };
    }

    if (!mountIdentify && main?.accountantUuidSelected && auth?.loginAuth?.id && studioFind && window?.aptrinsic) {
      setMountIdentify(true);

      identifyUserAndAccount({
        user: {
          id: normalizeAndHash(auth?.loginAuth?.id),
          email: profilingCookiesAccepted ? user?.profile?.tsid : "Email",
          firstName: profilingCookiesAccepted ? user?.profile?.firstName : "FirstName",
          lastName: profilingCookiesAccepted ? user?.profile?.lastName : "LastName",
          language: user?.profile?.language,
          userConsent: profilingCookiesAccepted,
        },
        account: {
          id: normalizeAndHash(`ONEP_CORE_REGISTRY_ITEM_${studioFind.id}`),
          // uuid: userType !== "STUDIO" ? preSelectedClient.id : studioArr[0].id,
          name: profilingCookiesAccepted ? studioFind?.ragioneSociale : "name",
          ONEP_CORE_REGISTRY_ITEM_taxIdentifier: profilingCookiesAccepted ? studioFind?.codiceFiscale : "taxId",
          ONEP_CORE_REGISTRY_ITEM_vatIdentifier: profilingCookiesAccepted ? studioFind.partitaIva : "vatNumber",
          ONEP_CORE_REGISTRY_ITEM_classifier: studioFind?.classifier,
          ONEP_CORE_REGISTRY_ITEM_countryCode: studioFind?.taxRegion,
        },
      });
    }
  }, [auth, studioFind, mountIdentify, setMountIdentify, main]);

  useEffect(() => {
    if (["es", "ES", "es-ES"].indexOf(user?.profile?.language) > -1) {
      moment.locale("es");
    } else {
      moment.locale("it");
    }
    if (window.OneTrust) {
      try {
        console.log("change OneTrust Language to " + user?.profile?.language?.split("-")[0]);
        window.OneTrust.changeLanguage(user?.profile?.language?.split("-")[0]);
      } catch (err) {
        window.OneTrust.changeLanguage("en");
      }
    }
  }, [user?.profile?.language]);

  return toRenderBlock;
};

export default Root;
